module.exports = __webpack_public_path__ + "static/media/slide-mobile (6).e2a695c6.jpg";